import {UserStatus} from '../../models/user.model';
import {Badge} from '../../../../Presentation/components/ui/Badge';
import {AppText} from '../../../../Presentation/components/ui/Typography';

export const getStatusBadgeVariant = (status: UserStatus) => {
  switch (status) {
    case UserStatus.ACTIVE:
      return 'success';
    case UserStatus.INACTIVE:
      return 'secondary';
    case UserStatus.SUSPENDED:
      return 'destructive';
    case UserStatus.PENDING:
      return 'warning';
    default:
      return 'secondary';
  }
};

export const getRoleDisplayName = (roleName: string, roles?: any[]) => {
  // Use dynamic role data from API instead of hardcoded mappings
  if (roles && roles.length > 0) {
    const role = roles.find(r => r.name === roleName);
    return role?.display_name || role?.name || roleName;
  }

  // Fallback to role name if no roles data available
  return roleName;
};

export const getStatusDisplayName = (status: string) => {
  const statusMap: Record<string, string> = {
    'active': 'نشط',
    'inactive': 'غير نشط',
    'suspended': 'معلق',
    'pending': 'في الانتظار'
  };
  return statusMap[status] || status;
};
